import { render, staticRenderFns } from "./CouponPlanCardParts.vue?vue&type=template&id=77c2a860&scoped=true"
import script from "./CouponPlanCardParts.vue?vue&type=script&lang=ts"
export * from "./CouponPlanCardParts.vue?vue&type=script&lang=ts"
import style0 from "./CouponPlanCardParts.vue?vue&type=style&index=0&id=77c2a860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c2a860",
  null
  
)

export default component.exports